import styled from 'styled-components';
import expand from '../../../images/expand.svg';

export const Container = styled.div`
  overflow: hidden;
  &.FaqItem{
    display: flex;
    align-items: center;
    background: #DDE5FA;
    box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
    border-radius: 10px;
    margin-bottom: 50px;
    padding: 25px 20px 25px 10px;
    position: relative;
    cursor: pointer;
    @media screen and (min-width: 768px) {
      padding: 37px 20px;
    }
  }
  &.FaqItem::after{
    content: url(${expand});
    position: absolute;
    right: 50px;
    transition: ease-in-out 0.15s;
  }
  &.RotateExpand::after{
    content: url(${expand});
    position: absolute;
    right: 50px;
    transform: rotate(180deg);
    transition: ease-in-out 0.15s;
  }
  
  & .ItemTitle{
    font-size: 16px;
    line-height: 150%;
    margin-left: 25px;
    margin-bottom: 0;
    
    @media screen and (min-width: 768px) {
      font-size: 24px;
    }
  }
`;

export const StyledH3 = styled.h3`
  margin-bottom: 0;
  margin-left: 23px;
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  color: #2C2B48;
  
  @media screen and (min-width: 768px) {
    font-size: 24px;
  }
`;
